import React, { type FC } from 'react';
import classNames from 'classnames';
import { gray } from '../../../components/Color';
import { AngleDownSmall } from '../../../components/Icons/AngleDownSmall';
import { AngleUpSmall } from '../../../components/Icons/AngleUpSmall';
import classes from '../styles/index.module.css';

type ToolNavigationCollapseButtonProps = {
	isExpanded: boolean;
	onClick: () => void;
	dataTestId?: string;
};

export const ToolNavigationCollapseButton: FC<ToolNavigationCollapseButtonProps> = ({
	isExpanded,
	onClick,
	dataTestId,
}) => {
	const buttonClasses = classNames(classes.toolNavigationItem__collapseButton, {
		[classes.toolNavigationItem__collapseButton_expanded]: isExpanded,
	});

	const Icon = isExpanded ? AngleUpSmall : AngleDownSmall;

	return (
		<button
			type='button'
			onClick={onClick}
			className={buttonClasses}
			aria-label='toggle module list'
			data-testid={dataTestId}
			aria-expanded={isExpanded}
		>
			<Icon color={gray[5]} />
		</button>
	);
};
